  let slideIndex = 1;
  showSlides(slideIndex);

  function plusSlides(n) {
    showSlides(slideIndex += n);
  }

  function currentSlide(n) {
    showSlides(slideIndex = n);
  }

  function showSlides(n) {
    let i;
    let slides = document.getElementsByClassName("mySlides");
    let dots = document.getElementsByClassName("dot");
    if (n > slides.length) {slideIndex = 1}    
    if (n < 1) {slideIndex = slides.length}
    for (i = 0; i < slides.length; i++) {
      slides[i].style.display = "none";  
    }
    for (i = 0; i < dots.length; i++) {
      dots[i].className = dots[i].className.replace(" active", "");
    }
    slides[slideIndex-1].style.display = "block";  
    dots[slideIndex-1].className += " active";
  }

  // Touch events for sliding on mobile
  let touchStartX = 0;
  let touchEndX = 0;

  document.querySelector('.slideshow-container').addEventListener('touchstart', function(event) {
    touchStartX = event.touches[0].clientX;
  });

  document.querySelector('.slideshow-container').addEventListener('touchend', function(event) {
    touchEndX = event.changedTouches[0].clientX;
    handleSwipe();
  });

  function handleSwipe() {
    if (touchStartX - touchEndX > 50) {
      plusSlides(1); // Swipe left, show next slide
    } else if (touchEndX - touchStartX > 50) {
      plusSlides(-1); // Swipe right, show previous slide
    }
  }

    let startX;
    let endX;

    document.querySelector('.slideshow-container').addEventListener('touchstart', function(event) {
      startX = event.touches[0].clientX;
    });

    document.querySelector('.slideshow-container').addEventListener('touchend', function(event) {
      endX = event.changedTouches[0].clientX;
      handleSwipe();
    });

    function handleSwipe() {
      if (startX - endX > 50) {
        plusSlides(1); // Swipe left -> next slide
      } else if (endX - startX > 50) {
        plusSlides(-1); // Swipe right -> previous slide
      }
    }